import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

const LazyGiftCardDelivery = lazy(
  () => import(/* webpackChunkName: 'GiftCardDelivery' */ './Delivery'),
);

export default function GiftCardDelivery() {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyGiftCardDelivery />
    </Suspense>
  );
}
